import type { VisibilityOnDevicesValue } from '@elfsight/configurator-contracts';
import { COMMON_MOBILE_BREAKPOINT } from '@elfsight/lib-utils';

export const isVisibleOnDevice = (
  mode?: VisibilityOnDevicesValue,
  windowWidth?: number
) => {
  const isMobile = Number(windowWidth) < COMMON_MOBILE_BREAKPOINT;

  if (!mode) {
    return true;
  }

  return (
    mode === 'allDevices' ||
    (isMobile && mode === 'mobileOnly') ||
    (!isMobile && mode === 'desktopOnly')
  );
};
